import axios from 'axios';
// eslint-disable-next-line max-len
// axios.defaults.headers.common['Authorization'] = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywibmFtZSI6IlJpZ29iZXJ0byBTYW5jaGV6IiwidXNlcm5hbWUiOiJyaWdvYmVydG8uc2FuY2hlekBnbWFpbC5jb20iLCJlbWFpbCI6InJpZ29iZXJ0by5zYW5jaGV6QGdtYWlsLmNvbSIsImlhdCI6MTYxMzU0NjQyOCwiZXhwIjoxNjQ1MDgyNDI4fQ.w1PK7ftKrbA9jg-LGwHFXiNU-Xtfa3YDblV0AwGBpuM"
/**
 * Allows retrying a failed get request.
 * @author José Rafael Gutierrez
 * @param url
 * @param options
 * @param retries
 * @return {Promise<AxiosResponse<T>>}
 */
export async function fetchRetry({ url, options = {}, retries = 3 }) {
  return await axios
    .get(url, options)
    .then(response => response)
    .catch(e => {
      if (retries > 0) return fetchRetry({ url: url, options: options, retries: retries - 1 });
      return e;
    });
}
